<template>
  <div id="app" v-dynamic-title="generateTitle()">
    <router-view/>
  </div>
</template>

<script>
  import dynamicTitle from './directives/vue-dynamic-title'
  export default {
    name: 'App',
    mixins: [dynamicTitle]
  }
</script>
